"use client";

import { captureUtmData } from "@/utils/utm";
import { useEffect } from "react";

export default function UtmCapture() {
  useEffect(() => {
    captureUtmData();
  }, []);

  return null;
}
